import React, { FC } from 'react';
import { graphql } from 'gatsby';
import { handleRipple } from '../../helpers/ripple';
import { useMPCWidget } from '../../helpers/useMPCWidget';
import {
  StyledSection,
  StyledContentBlock,
  MainContainer,
  MainWrapperDesktop,
  FirstRowWrapperDesktop,
  BlueSection,
  ContentWrapper,
  TextWrapper,
  Title,
  Text,
  ButtonWrapper,
  SignUpButton,
  GetAppButton,
  BitcoinSection,
  BitcoinImage,
  SecondRowWrapperDesktop,
  DesktopImageSection1,
  DesktopImage1,
  DesktopImageSection2,
  AppTitle,
  DesktopImage2,
  MainWrapperTablet,
  FirstRowWrapperTablet,
  SecondRowWrapperTablet,
  MainWrapperMobile,
  ImageRowMobile,
} from './styled';

interface Props {
  // hasScrolled: boolean;
}

const ReadytoGetStarted: FC<Props & Queries.SeoReadytoGetStartedFragment> = ({ readytogetstarted }) => {
  const { hasAccount, handleLoginClick } = useMPCWidget();

  const handleDashboardButton = async () => {
    window.open(readytogetstarted?.viewDashboardLink || undefined, '_blank');
  };

  return (
    <StyledSection>
      <StyledContentBlock>
        {readytogetstarted && (
          <MainContainer>
            <MainWrapperDesktop>
              <FirstRowWrapperDesktop>
                <BlueSection>
                  <ContentWrapper>
                    <TextWrapper>
                      <Title>{readytogetstarted?.title}</Title>
                      <Text>{readytogetstarted?.text}</Text>
                    </TextWrapper>
                    <ButtonWrapper>
                      {!hasAccount ? (
                        <SignUpButton
                          onClick={handleLoginClick}
                          onMouseEnter={handleRipple}
                        >
                          {readytogetstarted?.buttonText1}
                        </SignUpButton>
                      ) : (
                        <SignUpButton
                          onClick={() => handleDashboardButton()}
                          onMouseEnter={handleRipple}
                        >
                          {readytogetstarted?.viewDashboardButton}
                        </SignUpButton>
                      )}
                      <GetAppButton
                        href={readytogetstarted?.buttonLink2 || undefined}
                        target="_blank"
                        onMouseEnter={handleRipple}
                      >
                        {readytogetstarted?.buttonText2}
                      </GetAppButton>
                    </ButtonWrapper>
                  </ContentWrapper>
                </BlueSection>
                <BitcoinSection>
                  <BitcoinImage
                    src={readytogetstarted?.image1?.src || undefined}
                    alt={readytogetstarted?.image1?.alt || undefined}
                  />
                </BitcoinSection>
              </FirstRowWrapperDesktop>
              <SecondRowWrapperDesktop>
                <DesktopImageSection1>
                  <DesktopImage1
                    src={readytogetstarted?.image2?.src || undefined}
                    alt={readytogetstarted?.image2?.alt || undefined}
                  />
                </DesktopImageSection1>
                <DesktopImageSection2>
                  <AppTitle>{readytogetstarted?.appTitle}</AppTitle>
                  <DesktopImage2
                    src={readytogetstarted?.image3?.src || undefined}
                    alt={readytogetstarted?.image3?.alt || undefined}
                  />
                </DesktopImageSection2>
              </SecondRowWrapperDesktop>
            </MainWrapperDesktop>
            <MainWrapperTablet>
              <FirstRowWrapperTablet>
                <BlueSection>
                  <ContentWrapper>
                    <TextWrapper>
                      <Title>{readytogetstarted?.title}</Title>
                      <Text>{readytogetstarted?.text}</Text>
                    </TextWrapper>
                    <ButtonWrapper>
                      {!hasAccount ? (
                        <SignUpButton
                          onClick={handleLoginClick}
                          onMouseEnter={handleRipple}
                        >
                          {readytogetstarted?.buttonText1}
                        </SignUpButton>
                      ) : (
                        <SignUpButton
                          onClick={() => handleDashboardButton()}
                          onMouseEnter={handleRipple}
                        >
                          {readytogetstarted?.viewDashboardButton}
                        </SignUpButton>
                      )}
                      <GetAppButton
                        href={readytogetstarted?.buttonLink2 || undefined}
                        target="_blank"
                        onMouseEnter={handleRipple}
                      >
                        {readytogetstarted?.buttonText2}
                      </GetAppButton>
                    </ButtonWrapper>
                  </ContentWrapper>
                </BlueSection>
              </FirstRowWrapperTablet>
              <SecondRowWrapperTablet>
                <BitcoinSection>
                  <BitcoinImage
                    src={readytogetstarted?.image1?.src || undefined}
                    alt={readytogetstarted?.image1?.alt || undefined}
                  />
                </BitcoinSection>
                <DesktopImageSection1>
                  <DesktopImage1
                    src={readytogetstarted?.image2?.src || undefined}
                    alt={readytogetstarted?.image2?.alt || undefined}
                  />
                </DesktopImageSection1>
                <DesktopImageSection2>
                  <AppTitle>{readytogetstarted?.appTitle}</AppTitle>
                  <DesktopImage2
                    src={readytogetstarted?.image3?.src || undefined}
                    alt={readytogetstarted?.image3?.alt || undefined}
                  />
                </DesktopImageSection2>
              </SecondRowWrapperTablet>
            </MainWrapperTablet>
            <MainWrapperMobile>
              <BlueSection>
                <ContentWrapper>
                  <TextWrapper>
                    <Title>{readytogetstarted?.title}</Title>
                    <Text>{readytogetstarted?.text}</Text>
                  </TextWrapper>
                  <ButtonWrapper>
                    {!hasAccount ? (
                      <SignUpButton
                        onClick={handleLoginClick}
                        onMouseEnter={handleRipple}
                      >
                        {readytogetstarted?.buttonText1}
                      </SignUpButton>
                    ) : (
                      <SignUpButton
                        onClick={() => handleDashboardButton()}
                        onMouseEnter={handleRipple}
                      >
                        {readytogetstarted?.viewDashboardButton}
                      </SignUpButton>
                    )}
                    <GetAppButton
                      href={readytogetstarted?.buttonLink2 || undefined}
                      target="_blank"
                      onMouseEnter={handleRipple}
                    >
                      {readytogetstarted?.buttonText2}
                    </GetAppButton>
                  </ButtonWrapper>
                </ContentWrapper>
              </BlueSection>
              <ImageRowMobile>
                <BitcoinSection>
                  <BitcoinImage
                    src={readytogetstarted?.image1?.src || undefined}
                    alt={readytogetstarted?.image1?.alt || undefined}
                  />
                </BitcoinSection>
                <DesktopImageSection1>
                  <DesktopImage1
                    src={readytogetstarted?.image2?.src || undefined}
                    alt={readytogetstarted?.image2?.alt || undefined}
                  />
                </DesktopImageSection1>
              </ImageRowMobile>
              <DesktopImageSection2>
                <AppTitle>{readytogetstarted?.appTitle}</AppTitle>
                <DesktopImage2
                  src={readytogetstarted?.image3?.src || undefined}
                  alt={readytogetstarted?.image3?.alt || undefined}
                />
              </DesktopImageSection2>
            </MainWrapperMobile>
          </MainContainer>
        )}
      </StyledContentBlock>
    </StyledSection>
  );
};

export const query = graphql`
  fragment SeoReadytoGetStarted on Json {
    readytogetstarted {
      title
      text
      buttonText1
      viewDashboardButton
      viewDashboardLink
      buttonText2
      buttonLink2
      appTitle
      image1 {
        src
        alt
      }
      image2 {
        src
        alt
      }
      image3 {
        src
        alt
      }
    }
  }
`;

export default ReadytoGetStarted;
